import { LeanFormSchema } from '../types/config-form.types';
import { fieldRef } from '../types/config-form.types';
import {
  V3DeviceWorkModeConfig,
  V3DeviceWorkModeTOU,
  V3DeviceWorkModeTiming,
  V3DeviceWorkModePassive,
} from 'ngx-modbus';

export const WORK_MODE_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'work-mode-settings',
  name: 'Work Mode Settings',
  modeSelector: {
    registerKey: 'WORK_MODE',
    key: 'WORK_MODE',
    labelKey: 'energyStorageModeControl',
    registerTable: 'V3DeviceWorkModeConfig',
    settingsCode: 'EnergyStorageModeControl',
  },
  sections: [
    {
      id: 'tou',
      labelKey: 'timeOfUseElectricityPriceModel',
      modeValue: 1,
      registerTable: 'V3DeviceWorkModeTOU',
      controlRegister: 'TOU_Control',
      sectionSelector: {
        registerKey: 'TOU_ID',
        labelKey: 'ruleSelector',
        applyMode: 'immediate',
        alwaysIncludeInSectionWrites: true,
      },
      fields: [
        fieldRef(V3DeviceWorkModeTOU, 'TOU_On_Off_Control'),
        fieldRef(V3DeviceWorkModeTOU, 'TOU_Charge_Start'),
        fieldRef(V3DeviceWorkModeTOU, 'TOU_Charge_End'),
        fieldRef(V3DeviceWorkModeTOU, 'TOU_Charge_Target_SOC'),
        fieldRef(V3DeviceWorkModeTOU, 'TOU_Charge_Power'),
        fieldRef(V3DeviceWorkModeTOU, 'TOU_Executed_Date_Start'),
        fieldRef(V3DeviceWorkModeTOU, 'TOU_Executed_Date_End'),
        fieldRef(V3DeviceWorkModeTOU, 'TOU_Executed_Day_of_Week'),
      ],
    },
    {
      id: 'timing',
      labelKey: 'timingChargingAndDischargingMode',
      modeValue: 2,
      registerTable: 'V3DeviceWorkModeTiming',
      controlRegister: 'TIMING_CONTROL',
      sectionSelector: {
        registerKey: 'TIMING_ID',
        labelKey: 'ruleSelector',
        applyMode: 'immediate',
        alwaysIncludeInSectionWrites: true,
      },
      fields: [
        fieldRef(V3DeviceWorkModeTiming, 'TIMING_OFF_ON_CONTROL'),
        fieldRef(V3DeviceWorkModeTiming, 'TIMING_CHARGE_START'),
        fieldRef(V3DeviceWorkModeTiming, 'TIMING_CHARGE_END'),
        fieldRef(V3DeviceWorkModeTiming, 'TIMING_DISCHARGE_START'),
        fieldRef(V3DeviceWorkModeTiming, 'TIMING_DISCHARGE_END'),
        fieldRef(V3DeviceWorkModeTiming, 'TIMING_CHARGE_POWER'),
        fieldRef(V3DeviceWorkModeTiming, 'TIMING_DISCHARGE_POWER'),
      ],
    },
    {
      id: 'passive',
      labelKey: 'passiveMode',
      modeValue: 3,
      registerTable: 'V3DeviceWorkModePassive',
      fields: [
        fieldRef(V3DeviceWorkModePassive, 'Passive_Manual_Blo'),
        fieldRef(V3DeviceWorkModePassive, 'Passive_Manual_Bup'),
        fieldRef(V3DeviceWorkModePassive, 'Passive_Manual_Gdes'),
      ],
    },
  ],
  presets: [
    {
      id: 'tou-day-charge',
      label: 'Day Charging (TOU)',
      description: 'Charge during daytime off-peak hours (10:00-16:00)',
      icon: 'sunny-outline',
      matIcon: 'wb_sunny',
      forModes: [1],
      values: {
        TOU_On_Off_Control: 1,
        TOU_Charge_Start: [10, 0],
        TOU_Charge_End: [16, 0],
        TOU_Charge_Target_SOC: 100,
        TOU_Executed_Date_Start: [1, 1],
        TOU_Executed_Date_End: [12, 31],
        TOU_Executed_Day_of_Week: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      },
    },
    {
      id: 'tou-night-charge',
      label: 'Night Charging (TOU)',
      description: 'Charge during nighttime off-peak hours (23:00-06:00)',
      icon: 'moon-outline',
      matIcon: 'nightlight_round',
      forModes: [1],
      values: {
        TOU_On_Off_Control: 1,
        TOU_Charge_Start: [23, 0],
        TOU_Charge_End: [6, 0],
        TOU_Charge_Target_SOC: 100,
        TOU_Executed_Date_Start: [1, 1],
        TOU_Executed_Date_End: [12, 31],
        TOU_Executed_Day_of_Week: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
    },
    {
      id: 'timing-balanced',
      label: 'Balanced Schedule',
      description: 'Charge in morning, discharge in evening',
      icon: 'swap-horizontal-outline',
      matIcon: 'swap_horiz',
      forModes: [2],
      values: {
        TIMING_OFF_ON_CONTROL: 3,
        TIMING_CHARGE_START: [6, 0],
        TIMING_CHARGE_END: [10, 0],
        TIMING_DISCHARGE_START: [17, 0],
        TIMING_DISCHARGE_END: [22, 0],
        TIMING_CHARGE_POWER: 3000,
        TIMING_DISCHARGE_POWER: 3000,
      },
    },
    {
      id: 'passive-zero-export',
      label: 'Zero Export',
      description: 'Minimize grid export',
      icon: 'remove-circle-outline',
      matIcon: 'block',
      forModes: [3],
      values: {
        Passive_Manual_Gdes: 0,
        Passive_Manual_Blo: -5000,
        Passive_Manual_Bup: 5000,
      },
    },
    {
      id: 'passive-max-self-consume',
      label: 'Max Self-Consumption',
      description: 'Maximize self-consumption from battery',
      icon: 'battery-charging-outline',
      matIcon: 'battery_charging_full',
      forModes: [3],
      values: {
        Passive_Manual_Gdes: 0,
        Passive_Manual_Blo: -10000,
        Passive_Manual_Bup: 10000,
      },
    },
  ],
};
